import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, CircularProgress } from '@mui/material';
import { showAlert } from '../../store/slices/alertSlice';
import { resetOrder } from '../../store/slices/wholesaleOrderSlice';
import { useCreateOrder } from './wholesaleuser.hooks';
import { useNavigate } from 'react-router-dom';
export default function SubmitOrder() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const orderData = useSelector((state) => state.order);

  const [clicked, setClicked] = React.useState(false);
  const {
    mutate,
    isLoading,
  } = useCreateOrder({
    onSuccess: () => {
      dispatch(showAlert({ severity: 'success', title: 'Order created successfully!' }));
      dispatch(resetOrder());
      navigate('/wholesaleorder/manage');
    },
    onError: (error) => {
      dispatch(
        showAlert({
          severity: 'error',
          title:
            error?.response?.data?.message ||
            error.message ||
            'Failed to create order.',
        })
      );
    },
    onSettled: () => {
      setClicked(false);
    }
  });

  const handleSubmit = (e) => {

    e.preventDefault();
    if (clicked) return;
    setClicked(true);
    mutate(orderData); 
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleSubmit}
      disabled={isLoading}
      sx={{ mt: 2 }}
    >
      {isLoading ? <CircularProgress size={24} /> : 'Submit Order'}
    </Button>
  );
}
